<template>
  <div class="warranty-coverage">
    <base-son-title
      enTitle="Warranty Coverage"
      title="保修" title1="范围"
      class="animate__animated animate__zoomIn"
    >
    </base-son-title>
    <div class="marked-words animate__animated animate__zoomIn">
      <p class="text-1">尊敬的用户</p>
      <p class="text-2">若您的爱车在质保期内出现相关问题，VOGE售后服务会为您及时清除障碍，祝您尽享驾驶乐趣，您可在以下表格了解VOGE提供的保修范围</p>
    </div>
    <div style="display: flex;align-items: center;justify-content: right;">
      <a class="link" href="https://vogemotor.com/2024voge-warranty-coverage.pdf">点击查看VOGE无极系列车型三包服务完整手册</a>
    </div>
    <!-- 发动机 -->
    <div class="warranty-list" :class="{'animate__animated animate__slideInUp':engineShow}" ref="engine">
      <p class="text-1">发动机</p>
      <el-table :data="tableDataEngine" border style="width: 100%" :span-method="arraySpanMethodEngine">
        <el-table-column label="VOGE无极系列车型三包服务范围 (注册用户)">
          <el-table-column prop="classification" label="分类" width="150">
          </el-table-column>
          <el-table-column prop="affiliation" label="归属" width="150"> </el-table-column>
          <el-table-column prop="designation" label="零件名称" width="500"> </el-table-column>
        </el-table-column>
        <el-table-column label="VOGE无极车型 (赠送延保服务车型除外)" width="500">
        <el-table-column prop="content" label="三包有效期"> </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 整车 -->
    <div class="warranty-list" :class="{'animate__animated animate__slideInUp':carShow}" ref="car">
      <p class="text-1">整车</p>
      <el-table :data="tableDataCar" border style="width: 100%" :span-method="arraySpanMethodCar">
        <el-table-column label="VOGE无极系列车型三包服务范围 (注册用户)">
          <el-table-column prop="classification" label="分类" width="150">
          </el-table-column>
          <el-table-column prop="affiliation" label="归属" width="150"> </el-table-column>
          <el-table-column prop="designation" label="零件名称" width="500"> </el-table-column>
        </el-table-column>
        <el-table-column label="VOGE无极车型 (赠送延保服务车型除外)" width="500">
        <el-table-column prop="content" label="三包有效期"> </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 其他 -->
    <div class="warranty-list" :class="{'animate__animated animate__slideInUp':otherShow}" ref="other">
      <p class="text-1">其他</p>
      <el-table :data="tableDataOther" border style="width: 100%" :span-method="arraySpanMethodOther">
        <el-table-column label="VOGE无极系列车型三包服务范围 (未注册用户)">
          <el-table-column prop="classification" label="分类" width="150">
          </el-table-column>
          <el-table-column prop="affiliation" label="归属" width="150"> </el-table-column>
          <el-table-column prop="designation" label="零件名称" width="500"> </el-table-column>
        </el-table-column>
        <el-table-column label="VOGE无极车型 (赠送延保服务车型除外)" width="500">
        <el-table-column prop="content" label="三包有效期"> </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 其他 -->
    <div class="warranty-list" v-if="ysjshow" :class="{'animate__animated animate__slideInUp':otherShow}" ref="other">
      <p class="text-1">易损、易耗件</p>
      <el-table :data="tableDataYsYh" border style="width: 100%" :span-method="arraySpanMethodYsYh">
        <el-table-column label="VOGE无极系列车型三包服务范围">
          <el-table-column prop="classification" label="分类" width="150"></el-table-column>
          <el-table-column prop="designation" label="零件名称" width="500"> </el-table-column>
        </el-table-column>
        <el-table-column label="VOGE无极车型 (赠送延保服务车型除外)" width="500">
          <el-table-column prop="content" label="三包有效期"> </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import BaseSonTitle from "@/components/BaseSonTitle.vue";
export default {
  components:{
    BaseSonTitle,
  },
  data(){
    return{
      currentScroll: null,
      engineShow:false,
      carShow:false,
      ysjshow: false,
      otherShow:false,
      // 整车表格数据
      tableDataEngine: [
        {
          classification:'发动机',
          affiliation: '曲轴箱体部分',
          designation: '左曲轴箱体、右曲轴箱体、右曲轴箱盖、左前盖、轴瓦(箱体、传动箱体）',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '曲轴部分',
          designation: '曲柄连杆部件（曲轴部件）、轴瓦(曲轴）、连杆组合',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '磁电机组件',
          designation: '磁电机转子部件、磁电机锭子部件、超越离合器（起动离合器本体组合）',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '离合器组件',
          designation: '离合器外罩组合、离合器中心套(不含摩擦片)',
          content: '一年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '气缸头部件',
          designation: '气缸头（不含气缸头盖）、气缸体、凸轮轴支架、凸轮轴组合、气缸头盖',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '活塞总成',
          designation: '活塞、活塞销',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '配气机构',
          designation: '进气门、排气门、正时从动轮、气门摇臂组合',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '配气机构',
          designation: '链条导向轮、链条导向板、正时链条、张紧器',
          content: '一年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '变速机构',
          designation: '变速鼓、五星拨板、拨叉、拨叉轴、换档臂部件',
          content: '两年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'发动机',
          affiliation: '传动机构',
          designation: '主轴部件、副轴部件、传动主轴、传动副轴组合、输出轴部件',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '平衡轴部分',
          designation: '平衡轴齿轮副、平衡轴部件',
          content: '两年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'发动机',
          affiliation: '起动电机部件',
          designation: '起动电机组件 、电起动双联齿轮、电起动过桥齿轮、盘形齿轮',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '机油泵总成',
          designation: '机油泵部件、机油泵转子组合、油泵传动轴',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '冷却系统',
          designation: '冷却泵部件、节温器、各类传感器',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
      ],
      // 发动机表格数据
      tableDataCar: [
        {
          classification:'整车',
          affiliation: '转向操纵系统',
          designation: '方向柱本体 （ 脱焊 断裂）、手把',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '机架部分',
          designation: '平叉、车架（ 脱焊 断裂）',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '电气系统',
          designation: '主电缆',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '电气系统',
          designation: '闸把部件、点火线圈、全车锁、风扇组件、仪表组件、电子燃油泵、控制器（ 包含混动）、喇叭、 T- BOX、 BCM 、遥控钥匙、速度传感线、 USB充电器、 大灯控制器、 闪光器、 继电器、电器盒、 刹车开关 、蓄电池（ 含动力锂电池）、 手把加热 、雷达传感器、 玻璃升降器、 胎压传感器、 行车记录仪',
          content: '一年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '电喷系统',
          designation: '节气门、电子控制器ECU、氧传感器、进气温度压力传感器、节气门位置传感器、怠速控制阀、水温传感器、 侧倾传感器',
          content: '一年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '燃油冷却系统',
          designation: '油箱（ 生锈 脱焊）、散热器、燃油蒸发控制组件、冷却水箱',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '行驶制动系统',
          designation: '发前后减震器、缓冲体',
          content: '一年 （不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '行驶制动系统',
          designation: '皮带 、皮带轮',
          content: '一年或10000公里',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '行驶制动系统',
          designation: '前后铝轮',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '行驶制动系统',
          designation: '前后网轮',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '行驶制动系统',
          designation: '碟刹上泵、碟刹下泵、ABS防抱死装置',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '电气系统',
          designation: '前照灯、尾灯、转向灯、副灯',
          content: '一年（10000公里）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '进排气系统',
          designation: '消声器体后段、排气管（ 脱焊 内芯脱落 断裂）、空滤器',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '辅助部分',
          designation: '后扶手、主站架、侧支架（ 脱焊断裂） 搁脚部件（ 脱漆）',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        }
      ],
      //其他表格数据
      tableDataOther: [
        {
          classification:'其他',
          affiliation: '发动机',
          designation: 'CVT皮带',
          content: '三个月内3000公里',
          content1:'一年或6000公里'
        },
        {
          classification:'其他',
          affiliation: '发动机',
          designation: '火花塞（裂纹、断裂、烧蚀）',
          content: '三个月内3000公里',
          content1:'六个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '发动机',
          designation: '初级主动齿轮、初级从动齿轮（断齿、开裂）',
          content: '六个月内6000公里',
          content1:'六个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '轴承、衬套、密封圈',
          content: '三个月内3000公里',
          content1:'一年或6000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '碟刹盘',
          content: '三个月内3000公里',
          content1:'6个月或6000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '坐垫摇架',
          content: '一年内不限里程',
          content1:'一年或6000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '全车覆盖件（锈蚀、变色、起层、龟裂）',
          content: '三个月内3000公里',
          content1:'3个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '空滤器总成',
          content: '三个月内3000公里',
          content1:'3个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '制动蹄块',
          content: '不在保修范围',
          content1:'3个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '油门拉索、离合线拉索',
          content: '六个月内6000公里',
          content1:'3个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '链条',
          content: '一年内3000公里',
          content1:'3个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '整车',
          designation: '刹车片',
          content: '不在保修范围',
          content1:'3个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '易损件塑料件',
          designation: '保险丝、灯泡、内胎、滤芯、离合器摩擦片、传动链轮链条、火花塞制动液、贴纸等消耗易损件',
          content: '不在保修范围',
          content1:'3个月或3000公里'
        },
      ],
      //其他表格数据
      tableDataYsYh: [
        {
          classification:'易损、易耗件',
          designation: '烤漆外观覆盖件（锈蚀、变色、起层、龟裂）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '全车油封（漏油、过度磨损）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '全车轴承（过度磨损、碎裂）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '后视镜（脱落、滑丝、连接松动）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '内外胎（鼓包、起层、老化开裂）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '大小链盘断齿（正常使用状态）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: 'CVT主、从动轮（正常使用状态）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '驱动链条断裂（正常使用状态）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: 'CVT皮带（正常使用状态）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '速度计齿轮（涡轮、涡杆）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '空滤器（不含滤芯）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '各种软轴、拉索线芯断裂',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '防盗器失灵',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '正时链条拉长（通过调节不能解决的）',
          content: '1个月或行驶6000公里',
          content1:'1个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '正时链条断裂',
          content: '1年或行驶6000公里',
          content1:'1年或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '火花塞（裂纹、断裂、烧蚀）',
          content: '3个月或3000公里',
          content1:'3个月或3000公里'
        },
      ],
    }
  },
  mounted(){
    window.addEventListener('scroll',this.handleScroll)
  },
  methods:{
    arraySpanMethodEngine({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % this.tableDataEngine.length === 0) {
          return {
            rowspan: this.tableDataEngine.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    arraySpanMethodCar({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % this.tableDataCar.length === 0) {
          return {
            rowspan: this.tableDataCar.length,
            colspan: 1
          };
        }
        else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    arraySpanMethodOther({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % this.tableDataOther.length === 0) {
          return {
            rowspan: this.tableDataOther.length,
            colspan: 1
          };
        }
        else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    arraySpanMethodYsYh({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % this.tableDataYsYh.length === 0) {
          return {
            rowspan: this.tableDataYsYh.length,
            colspan: 1
          };
        }
        else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    handleScroll(){
      this.currentScroll = window.pageYOffset
      let engineViewTop = this.$refs.engine.getBoundingClientRect()
      if (engineViewTop.top <= window.innerHeight && engineViewTop.bottom >= 0) {
					this.engineShow = true
			}
      let carViewTop = this.$refs.car.getBoundingClientRect()
      if (carViewTop.top <= window.innerHeight && carViewTop.bottom >= 0) {
					this.carShow = true
			}
      let otherViewTop = this.$refs.other.getBoundingClientRect()
      if (otherViewTop.top <= window.innerHeight && otherViewTop.bottom >= 0) {
					this.otherShow = true
			}
    }
  },
  destroyed(){
    window.removeEventListener('scroll',this.handleScroll)
  }
}
</script>

<style lang="scss">
.warranty-coverage{
  max-width: 1400px;
  margin: 0px auto;
  padding-bottom:50px;
  .marked-words{
    margin: 50px 0;
    p{
      text-align: center;
      margin-bottom: 15px;
    }
    .text-1{
      font-size: 18px;
    }
    .text-2{
      font-size: 14px;
    }
  }
  .warranty-list{
    .text-1{
      font-size: 18px;
      font-weight: 800;
    }
    .el-table{
      margin:30px 0;
    }
    .cell,.text-1{
      text-align: center;
    }
    .el-table th.el-table__cell{
      font-weight: 800;
      color: black;
      background-color: #FBCC0A;
    }
    .el-table tbody tr:hover > td {
      background-color: transparent;
    }
  }
}
.warranty-coverage {
  max-width: 1400px;
  margin: 0px auto;
  padding-bottom:50px;
  .marked-words{
    margin: 50px 0 20px 0;
    p{
      text-align: center;
      margin-bottom: 15px;
    }
    .text-1{
      font-size: 18px;
    }
    .text-2{
      font-size: 14px;
    }
  }
  .warranty-list{
    .text-1{
      font-size: 18px;
      font-weight: 800;
    }
    .el-table{
      margin:30px 0;
    }
    .cell,.text-1{
      text-align: center;
    }
    .el-table th.el-table__cell{
      font-weight: 800;
      color: black;
      background-color: #FBCC0A;
    }
    .el-table tbody tr:hover > td {
      background-color: transparent;
    }
  }
}
.link{
  color: #0080ff;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/serve/warranty-coverage/warranty-coverage.vue